import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  JOB_DETAILS_REFRESH: createSagaAction('JOB_DETAILS_REFRESH'),

  JOB_DETAILS_UPDATE: createSagaAction('JOB_DETAILS_UPDATE'),
  DELETE_JOB: createSagaAction('DELETE_JOB'),
  INACTIVATE_JOB: createSagaAction('INACTIVATE_JOB'),
  ACTIVATE_JOB: createSagaAction('ACTIVATE_JOB'),

  CHILDREN_JOBS: createSagaAction('CHILDREN_JOBS')
}

// Action Creators
export const actions = {
  fetchJobDetails: ({ jobId }) => ({
    type: constants.JOB_DETAILS_REFRESH.ACTION,
    jobId
  }),

  fetchChildrenJobs: ({ jobId }) => ({
    type: constants.CHILDREN_JOBS.ACTION,
    jobId
  }),

  updateJobDetails: ({ jobId, content }) => ({
    type: constants.JOB_DETAILS_UPDATE.ACTION,
    jobId,
    content
  }),

  deleteJob: ({ jobId, userId }) => ({
    type: constants.DELETE_JOB.ACTION,
    jobId,
    userId
  }),

  inactivateJob: ({ jobId, userId }) => ({
    type: constants.INACTIVATE_JOB.ACTION,
    jobId,
    userId
  }),

  activateJob: ({ jobId, userId }) => ({
    type: constants.ACTIVATE_JOB.ACTION,
    jobId,
    userId
  })
}

// Reducer
const initialState = [
  {
    createdDate: '',
    updatedDate: '',
    createdByFirstName: '',
    createdByLastName: '',
    updatedByFirstName: '',
    updatedByLastName: '',
    name: '',
    type: '',
    legacyJobId: '',
    CompanyName: '',
    parentJobId: '',
    description: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    delete: false
  }
]

export default createReducer(initialState, (state, { type, payload, childrenJobs }) => {
  switch (type) {
    default:
      return state
    case constants.JOB_DETAILS_REFRESH.SUCCESS:
      return { ...state, payload }
    case constants.CHILDREN_JOBS.SUCCESS:
      return { ...state, childrenJobs }
    case constants.JOB_DETAILS_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_JOB.SUCCESS:
      return { ...state, payload }

    case constants.INACTIVATE_JOB.SUCCESS:
      return { ...state, payload }

    case constants.ACTIVATE_JOB.SUCCESS:
      return { ...state, payload }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobDetails.js